<template lang="html">
    <div class="page" id="messages">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/messages.png" />
        </header>

        <div class="scroller2 grey">
            <header>
                <h2 v-if="!message"><span style="color: #eef5f2">_</span></h2>
                <h2 class="small" v-else>
                    {{ message.from.first_name }} {{ message.from.last_name }}
                </h2>
                <ul class="links">
                    <li>
                        <a
                            class="cancel"
                            @click.prevent="goToLocation({ name: 'playerMessagesAll' })"
                            href="#"
                        >
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <div v-if="!message">
                <pre-loader-item v-for="n in 5" :key="n" />
            </div>

            <div v-else class="copy">
                <span class="sender">
                    <span class="info large" style="margin-bottom: 10px">{{
                        this.$date(message.created_at).format("ddd D MMM")
                    }}</span>
                </span>

                <div class="content">
                    {{ message.message }}

                    <br />
                    <router-link
                        :to="{ name: 'offer', params: { id: message.offer.id } }"
                        v-if="message.offer"
                        >{{ message.offer.title }}</router-link
                    >
                    <br /><br />

                    <img class="image" v-if="message.image" :src="imageURL(message.image)" alt="" />
                </div>

                <button @click.prevent="deleteMessage" :disabled="busy" class="button red">
                    {{ busy ? "Please wait..." : "Delete message" }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { imageURL } from "@/mixins/imageURL.js";
import PreLoaderItem from "@/components/App/Pre-loader-item";
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
export default {
    name: "message",
    mixins: [imageURL],
    created() {
        this.getMessage();
    },
    components: { PreLoaderItem, FadeImage, XIcon },
    data() {
        return {
            message: false,
            busy: false,
        };
    },
    methods: {
        goToLocation($url) {
            if (this.$route.query.from) {
                this.$router.go(-1);
            } else {
                this.$router.push($url);
            }
        },
        getMessage() {
            window.axios.get("/message/" + this.$route.params.id).then((response) => {
                this.message = response.data;
                this.$store.dispatch("getMsgUnreadCount");
            });
        },
        deleteMessage() {
            this.$confirm(
                "Are you sure you want to delete this message?",
                () => {
                    this.busy = true;
                    window.axios
                        .delete("/message/" + this.$route.params.id)
                        .then(() => {
                            this.$notify("Message Deleted");
                            this.busy = false;
                            this.$store.dispatch("getMsgUnreadCount");
                            this.$router.push({ name: "playerMessagesAll" });
                        })
                        .catch(() => {
                            this.busy = false;
                        });
                },
                "Yes",
                "No",
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.copy {
    p {
        line-height: 1.5;
        word-break: break-word;
        white-space: pre-wrap;
        margin-bottom: 20px;
        font-weight: 200 !important;
    }
    img {
        max-width: 100%;
        margin-bottom: 20px;
    }
    .offer {
        display: block;
        background: white;
        padding: 20px;
        border-radius: $radius;
        color: $green_0;
    }
}
.sender {
    display: block;
    margin-bottom: 10px;

    i {
        float: right;
        color: lighten(#000000, 80);
    }
    .from {
        color: $green_0;
    }
}
.image {
    max-width: 100%;
}
.content {
    line-height: 1.5;
    font-weight: 200;
    background: white;
    padding: 17px;
    border-radius: $radius;
    margin-bottom: 30px;
    a,
    span {
        text-decoration: none;
        color: $green_1;
    }
}
</style>
